import Vue from 'vue'
import VueRouter from 'vue-router'
import act9901 from '../views/act_9901.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'act9901',
    component: act9901
  },
  // {
  //   path: '/act9901',
  //   name: 'act9901',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/act_9901.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
